import { render, staticRenderFns } from "./CreateDemand.vue?vue&type=template&id=24559c98&scoped=true&"
import script from "./CreateDemand.vue?vue&type=script&lang=js&"
export * from "./CreateDemand.vue?vue&type=script&lang=js&"
import style0 from "./CreateDemand.vue?vue&type=style&index=0&id=24559c98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24559c98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
